<template>
  <div class="ccleClass">
    <a-spin :spinning="spinning" :indicator="indicator">
      <!-- <a-row>
        <a-col :span="24">
          <a-popover
            v-model="visibleScore"
            trigger="hover"
            placement="rightTop"
          >
            <div slot="title">Help</div>
            <div slot="content" style="width: 600px">
              Waitting for writting!
            </div>
            <a-button type="danger" size="small">
              <a-icon type="question-circle" /><a-icon
                v-if="!this.visibleScore"
                type="caret-down" />
              <a-icon v-if="this.visibleScore" type="caret-up"
            /></a-button>
          </a-popover>
        </a-col>
      </a-row> -->
      <div v-if="this.inCCLE">
        <div>
          <a-button
            :type="typeF === cancer ? 'primary' : 'dashed'"
            style="margin-left: 5px; margin-top: 5px"
            v-for="(cancer, index) in cancer"
            :key="index"
            @click="handleButtonClick(cancer)"
          >
            {{ cancer }}
          </a-button>
        </div>

        <a-row>
          <a-col :span="24"> <div id="ccle"></div></a-col>
          <a-col :span="24">
            <a-input
              type="text"
              addon-before="Width : "
              addon-after="px"
              v-model="tWidth"
            />
            <br />
            <br />
            <a-input
              type="text"
              addon-before="Height: "
              addon-after="px"
              v-model="tHeight"
            />
          </a-col>
          <a-col :span="24" style="margin-top: 10px">
            <a-button type="primary" @click="changePlot()"
              >Set options</a-button
            >
          </a-col>
        </a-row>
      </div>
      <div v-else style="font-size: 20px; color: black">
        This gene does not have data on
        <a
          href="https://sites.broadinstitute.org/ccle/datasets"
          target="_blank"
        >
          CCLE
        </a>
        project.
      </div>
    </a-spin>
  </div>
</template>

<script>
import axios from "axios";
import Highcharts from "highcharts/highstock";
import HighchartsMore from "highcharts/highcharts-more";
import HighchartsDrilldown from "highcharts/modules/drilldown";
import Highcharts3D from "highcharts/highcharts-3d";
import exporting from "highcharts/modules/exporting";

HighchartsMore(Highcharts);
HighchartsDrilldown(Highcharts);
Highcharts3D(Highcharts);
exporting(Highcharts);

export default {
  data() {
    return {
      // 导出长宽
      tWidth: 0,
      tHeight: 0,
      pWidth: 800,
      pHeight: 400,
      // 其他参数
      visibleScore: false,
      spinning: false,
      inCCLE: true,
      cancer: [
        "breast",
        "autonomic_ganglia",
        "biliary_tract",
        "bone",
        "central_nervous_system",
        "endometrium",
        "haematopoietic_and_lymphoid_tissue",
        "kidney",
        "large_intestine",
        "liver",
        "lung",
        "oesophagus",
        "ovary",
        "pancreas",
        "pleura",
        "prostate",
        "salivary_gland",
        "skin",
        "small_intestine",
        "soft_tissue",
        "stomach",
        "thyroid",
        "upper_aerodigestive_tract",
        "urinary_tract",
      ],
      typeF: "breast",
      indicator: <a-icon type="sync" style="font-size: 50px" spin />,
    };
  },
  watch: {
    pWidth() {
      //先查ensgid
      (this.spinning = true),
        axios
          .get(
            "http://research.gzsys.org.cn/perturbdb/API/perturbedgene/perturbGene_basic.php",
            {
              params: { genename: this.$route.query.gene },
            }
          )
          .then((response) => {
            //this.ensgID = response.data[0]["ensgID"];
            //开始绘图
            axios
              .get(
                "http://research.gzsys.org.cn/perturbdb/API/perturbedgene/perturbGene_ccle.php",
                {
                  params: {
                    gene: response.data[0]["ensgId"],

                    datatype: "breast",
                  },
                }
              )
              .then((response) => {
                if (Array.isArray(response.data) && response.data.length > 0) {
                  // response.data 是一个非空数组
                  this.inCCLE = true;
                  this.moreChart(response.data, "Breast");
                } else {
                  // response.data 不是一个数组或者是一个空数组
                  // 处理相应的情况
                  this.inCCLE = false;
                }
                // console.log(response.data);
                this.spinning = false;
              });
          });
    },
    pHeight() {
      //先查ensgid
      (this.spinning = true),
        axios
          .get(
            "http://research.gzsys.org.cn/perturbdb/API/perturbedgene/perturbGene_basic.php",
            {
              params: { genename: this.$route.query.gene },
            }
          )
          .then((response) => {
            //this.ensgID = response.data[0]["ensgID"];
            //开始绘图
            axios
              .get(
                "http://research.gzsys.org.cn/perturbdb/API/perturbedgene/perturbGene_ccle.php",
                {
                  params: {
                    gene: response.data[0]["ensgId"],

                    datatype: "breast",
                  },
                }
              )
              .then((response) => {
                if (Array.isArray(response.data) && response.data.length > 0) {
                  // response.data 是一个非空数组
                  this.inCCLE = true;
                  this.moreChart(response.data, "Breast");
                } else {
                  // response.data 不是一个数组或者是一个空数组
                  // 处理相应的情况
                  this.inCCLE = false;
                }
                // console.log(response.data);
                this.spinning = false;
              });
          });
    },
  },
  mounted() {
    //先查ensgid
    (this.spinning = true),
      axios
        .get(
          "http://research.gzsys.org.cn/perturbdb/API/perturbedgene/perturbGene_basic.php",
          {
            params: { genename: this.$route.query.gene },
          }
        )
        .then((response) => {
          //this.ensgID = response.data[0]["ensgID"];
          //开始绘图
          axios
            .get(
              "http://research.gzsys.org.cn/perturbdb/API/perturbedgene/perturbGene_ccle.php",
              {
                params: {
                  gene: response.data[0]["ensgId"],

                  datatype: "breast",
                },
              }
            )
            .then((response) => {
              if (Array.isArray(response.data) && response.data.length > 0) {
                // response.data 是一个非空数组
                this.inCCLE = true;
                this.moreChart(response.data, "Breast");
              } else {
                // response.data 不是一个数组或者是一个空数组
                // 处理相应的情况
                this.inCCLE = false;
              }
              // console.log(response.data);
              this.spinning = false;
            });
        });
  },
  methods: {
    changePlot() {
      this.pWidth = this.tWidth;
      this.pHeight = this.tHeight;
    },
    capitalizeFirstLetter(string) {
      return string.replace(/^\w/, (c) => c.toUpperCase());
    },
    handleButtonClick(value) {
      this.typeF = value;
      this.spinning = true;
      //先查ensgid
      axios
        .get(
          "http://research.gzsys.org.cn/perturbdb/API/perturbedgene/perturbGene_basic.php",
          {
            params: { genename: this.$route.query.gene },
          }
        )
        .then((response) => {
          //this.ensgID = response.data[0]["ensgID"];
          //开始绘图
          axios
            .get(
              "http://research.gzsys.org.cn/perturbdb/API/perturbedgene/perturbGene_ccle.php",
              {
                params: {
                  gene: response.data[0]["ensgId"],

                  datatype: this.typeF,
                },
              }
            )
            .then((response) => {
              this.moreChart(
                response.data,
                this.capitalizeFirstLetter(this.typeF)
              );
              // console.log(response.data);
              this.spinning = false;
            });
        });
    },
    moreChart(data, data2) {
      if (this.chart) {
        this.chart.destroy();
      }
      // 初始化 Highcharts 图表
      this.chart = new Highcharts.chart("ccle", {
        //去掉水印
        credits: {
          enabled: false,
        },
        chart: {
          type: "column",
        },
        title: {
          text: data2 + " cancer cell lines",
        },
        // 导出
        exporting: {
          filename:
            "Expression of " +
            this.$route.query.gene +
            " in " +
            data2 +
            " cancer cell lines",
          // chartOptions: {
          //   // specific options for the exported image
          //   chart: {
          sourceWidth: this.pWidth,
          sourceHeight: this.pHeight,
          scale: 1,
          //   },
          // },
        },
        xAxis: {
          type: "category",
          labels: {
            rotation: 45, // 设置轴标签旋转角度
          },
          tickWidth: 2,
          tickColor: "black",
          lineWidth: 2,
          lineColor: "black",
          tickLength: 5,
          gridLineColor: "white",
        },
        yAxis: {
          title: {
            text: "TPM",
          },
          tickWidth: 2,
          tickColor: "black",
          lineWidth: 2,
          lineColor: "black",
          tickLength: 5,
          gridLineColor: "white",
        },
        legend: {
          enabled: false,
        },
        tooltip: {
          pointFormat: "Expression: <b>{point.y:.1f}</b>",
        },
        series: [
          {
            name: "总人口",
            data: data,
            color: "#4572a7",
            dataLabels: {
              enabled: true,
              rotation: -90,
              color: "#FFFFFF",
              align: "right",
              format: "{point.y:.1f}", // :.1f 为保留 1 位小数
              y: 10,
            },
          },
        ],
      });
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit css to this component only -->
<style scoped>
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>
